<template>
    <div class="bannervisual" ref="bannervisual">
        <h1 class="verticalcenter">
            <router-link to="/">Dante Castro</router-link>
        </h1>
    </div>
</template>


<script>
export default {
    methods: {
        getHeight() {
            return this.$refs.bannervisual.offsetHeight;
        }
    }
}
</script>


<style scoped>
    .bannervisual {
        width: fill;
        height: 6em;
        background: white;
        background-image: linear-gradient(to top, rgba(255,0,255,0.5), rgba(224,255,255,1.0));
    }
    .verticalcenter {
        margin: 0;
        position: relative;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    h1 a {
        color: rgb(44, 62, 80);
        font-size: 1.2em;
        text-decoration: none;
    }
</style>